<template>
    <div>
        <div class="tw-mb-2">
            <div
                class="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-4"
            >
                <div class="tw-flex tw-items-start tw-gap-4">
                    <button
                        @click="goBack"
                        class="tw-group tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-bg-gray-50 dark:tw-bg-gray-900 tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-md tw-shadow-sm tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-gray-100 dark:hover:tw-bg-gray-750 hover:tw-text-blue-600 dark:hover:tw-text-blue-400 tw-transition-all tw-duration-200 tw-mt-2"
                        title="Back"
                    >
                        <span
                            class="material-symbols-outlined tw-transform group-hover:tw--translate-x-1 tw-transition-transform tw-duration-200"
                            style="font-size: 18px; color: inherit;"
                        >
                            arrow_back
                        </span>
                    </button>

                    <div
                        class="tw-border-l tw-border-gray-300 dark:tw-border-gray-600 tw-h-10 tw-mt-2"
                    ></div>

                    <div>
                        <h1
                            class="text-6xl font-black leading-tight text-slate-900 dark:text-white"
                            style="-webkit-text-stroke: 1.5px currentColor;"
                        >
                            {{ $t("zone.updateZone") }}
                        </h1>
                        <p
                            style="font-size: 15px;"
                            class="text-slate-500 dark:text-slate-400"
                        >
                            {{ $t("zone.modifyZone") }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Zone Details Section - Fixed -->
        <ts-loading-banner :loading="loading">
            <div
                class="tw-bg-white dark:tw-bg-slate-900 tw-rounded-lg tw-border tw-border-slate-200 dark:tw-border-slate-800 tw-p-6 tw-shrink-0 tw-mb-6"
            >
                <div
                    class="tw-pl-0 tw-flex tw-items-center tw-gap-2 tw-pb-4 tw-border-b tw-border-slate-100 dark:tw-border-slate-800 tw-mb-6"
                >
                    <span
                        class="material-symbols-outlined tw-text-slate-400"
                        style="transform: translateY(-5px);"
                        >edit_location_alt</span
                    >
                    <h3
                        class="tw-text-xl tw-font-semibold heading-dark font-work-sans"
                    >
                        {{ $t("zone.zoneDetails") }}
                    </h3>
                </div>
                <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
                    <div class="tw-flex tw-flex-col tw-gap-2">
                        <label
                            class="tw-text-base tw-font-medium tw-text-slate-800 dark:tw-text-slate-300 font-work-sans"
                            for="zoneName"
                        >
                            {{ $t("zone.zoneName") }}
                            <span class="tw-text-red-500">*</span>
                        </label>
                        <input
                            v-model="model.name"
                            class="form-control tw-w-full tw-rounded-md tw-border tw-border-slate-300 dark:tw-border-slate-700 tw-bg-white dark:tw-bg-slate-850 tw-text-slate-900 dark:tw-text-white focus:tw-outline-none tw-shadow-sm placeholder:tw-text-slate-400 tw-py-2.5 tw-px-3 font-work-sans"
                            id="zoneName"
                            :placeholder="$t('zone.phZoneName')"
                            type="text"
                            :class="{
								'is-invalid': errors.has('name')
							}"
                        />
                        <div class="invalid-feedback" v-if="errors.has('name')">
								{{ errors.first("name") }}
						</div>
                        <p class="tw-text-xs tw-text-slate-500 font-work-sans">
                            {{ $t("zone.zoneNameTip") }}
                        </p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-gap-2">
                        <label
                            class="tw-text-base tw-font-medium tw-text-slate-700 dark:tw-text-slate-300 font-work-sans"
                            for="description"
                        >
                            {{ $t("zone.description") }}
                        </label>
                        <input
                            v-model="model.remarks"
                            class="form-control tw-w-full tw-rounded-md tw-border tw-border-slate-300 dark:tw-border-slate-700 tw-bg-white dark:tw-bg-slate-850 tw-text-slate-900 dark:tw-text-white focus:tw-outline-none tw-shadow-sm placeholder:tw-text-slate-400 tw-py-2.5 tw-px-3 font-work-sans"
                            id="description"
                            :placeholder="$t('zone.phZoneName')"
                            type="text"
                        />
                    </div>
                </div>
            </div>

            <!-- Assign Shops Section - Scrollable Table Only -->
            <div
                class="tw-flex-1 tw-flex tw-flex-col tw-overflow-hidden tw-mb-6"
            >
                <div
                    class="tw-bg-white dark:tw-bg-slate-900 tw-rounded-lg tw-border tw-border-slate-200 dark:tw-border-slate-800 tw-flex tw-flex-col tw-h-full tw-overflow-hidden"
                >
                    <!-- Header Section - Fixed -->
                    <div
                        class="tw-px-6 tw-py-3 tw-border-b tw-border-slate-200 dark:tw-border-slate-800 tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 tw-justify-between tw-items-start sm:tw-items-center tw-bg-slate-50/50 dark:tw-bg-slate-900 tw-shrink-0"
                    >
                        <div>
                            <h3
                                class="tw-text-xl tw-font-semibold tw-text-slate-900 dark:tw-text-white font-work-sans"
                            >
                                {{ $t("zone.assignShops") }}
                            </h3>
                            <p
                                class="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400 tw-mt-1 font-work-sans"
                            >
                                {{ $t("zone.selectShopDes") }}
                            </p>
                        </div>
                        <div
                            class="tw-flex tw-items-center tw-gap-3 tw-w-full sm:tw-w-auto"
                        >
                            <div class="tw-relative tw-w-full sm:tw-w-80">
                                <span
                                    class="tw-absolute tw-left-3 tw-text-slate-400 material-symbols-outlined tw-pointer-events-none search-icon"
                                    style="top: 50%; transform: translateY(-50%); line-height: 1; font-size: 20px;"
                                    >search</span
                                >
                                <input
                                    v-model="searchQuery"
                                    class="tw-w-full tw-pl-10 tw-pr-4 tw-py-2.5 tw-rounded-md tw-border tw-border-slate-300 tw-bg-white tw-text-sm tw-text-slate-900 tw-shadow-sm search-input focus:tw-outline-none focus:tw-ring-0 focus:tw-border-slate-300 font-work-sans"
                                    :placeholder="$t('zone.shopSearch')"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- Category Filters - Fixed -->
                    <div
                        class="tw-px-6 tw-py-4 tw-flex tw-gap-3 tw-border-b tw-border-slate-100 dark:tw-border-slate-800 tw-overflow-x-auto tw-shrink-0 tw-bg-gray-50 dark:tw-bg-slate-900"
                    >
                        <button
                            v-for="category in categories"
                            :key="category.id"
                            @click="handleCategoryClick(category)"
                            :class="[
                                'tw-px-4 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-semibold tw-whitespace-nowrap tw-transition-all tw-duration-200 font-work-sans',
                                activeCategory === category.id
                                    ? 'tw-bg-gray-900 tw-text-white tw-shadow-md dark:tw-bg-gray-700'
                                    : 'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200 hover:tw-bg-gray-50 dark:tw-bg-gray-800 dark:tw-text-gray-300 dark:tw-border-gray-700 dark:hover:tw-bg-gray-750'
                            ]"
                        >
                            {{ category.label }}
                        </button>
                    </div>

                    <!-- Table Section - Scrollable with Fixed Height -->
                    <div
                        class="tw-flex-1 tw-overflow-y-auto custom-scrollbar tw-relative"
                        style="max-height: 500px; min-height: 400px;"
                    >
                        <table
                            class="tw-w-full tw-text-left tw-border-collapse"
                        >
                            <thead
                                class="table-header-fixed tw-text-xs tw-font-semibold tw-text-slate-300 dark:tw-text-slate-400 tw-uppercase tw-tracking-wider font-work-sans tw-sticky tw-top-0 tw-z-10"
                            >
                                <tr>
                                    <th
                                        class="tw-p-3 tw-border-b tw-border-slate-200 dark:tw-border-slate-800 tw-bg-slate-50 dark:tw-bg-slate-800"
                                        style="width: 60px;"
                                    >
                                        <div class="tw-flex tw-justify-center">
                                            <input
                                                v-model="selectAll"
                                                @change="toggleSelectAll"
                                                class="custom-checkbox tw-w-4 tw-h-4"
                                                type="checkbox"
                                            />
                                        </div>
                                    </th>
                                    <th
                                        class="tw-p-3 tw-border-b tw-border-slate-200 dark:tw-border-slate-800 tw-bg-slate-50 dark:tw-bg-slate-800 tw-text-left"
                                    >
                                        {{ $t("zone.shopName") }}
                                    </th>
                                    <th
                                        class="tw-p-3 tw-border-b tw-border-slate-200 dark:tw-border-slate-800 tw-hidden sm:tw-table-cell tw-bg-slate-50 dark:tw-bg-slate-800 tw-text-left"
                                    >
                                        {{ $t("zone.address") }}
                                    </th>
                                    <th
                                        class="tw-p-3 tw-border-b tw-border-slate-200 dark:tw-border-slate-800 tw-bg-slate-50 dark:tw-bg-slate-800 tw-text-left"
                                    >
                                        {{ $t("zone.category") }}
                                    </th>
                                    <th
                                        class="tw-p-3 tw-border-b tw-border-slate-200 dark:tw-border-slate-800 tw-text-right tw-bg-slate-50 dark:tw-bg-slate-800"
                                    >
                                        {{ $t("zone.status") }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody
                                class="tw-divide-y tw-divide-slate-100 dark:tw-divide-slate-800 tw-text-sm font-work-sans"
                            >
                                <tr
                                    v-for="shop in shops"
                                    :key="shop.id"
                                    :class="[
                                        'tw-group hover:tw-bg-slate-50 dark:hover:tw-bg-slate-800/50 tw-transition-colors',
                                        selectedShops.includes(shop.id)
                                            ? 'selected-row'
                                            : ''
                                    ]"
                                >
                                    <td
                                        class="tw-p-3 tw-border-b tw-border-slate-100 dark:tw-border-slate-800"
                                        style="width: 60px;"
                                    >
                                        <div
                                            class="tw-flex tw-justify-center tw-items-center tw-relative"
                                        >
                                            <div
                                                v-if="
                                                    selectedShops.includes(
                                                        shop.id
                                                    )
                                                "
                                                class="selected-row-indicator"
                                            ></div>
                                            <input
                                                v-model="selectedShops"
                                                :value="shop.id"
                                                class="custom-checkbox tw-w-4 tw-h-4"
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                    <td class="tw-px-3 tw-py-2">
                                        <div
                                            class="tw-flex tw-items-center tw-gap-2"
                                        >
                                            <div
                                                :class="[
                                                    'tw-size-8 tw-rounded-lg tw-flex tw-items-center tw-justify-center shop-icon-container tw-flex-shrink-0',
                                                    shop.iconBg
                                                ]"
                                            >
                                                <span
                                                    class="material-symbols-outlined tw-text-[28px]"
                                                >
                                                    {{ shop.icon }}
                                                </span>
                                            </div>
                                            <div>
                                                <p
                                                    class="tw-font-semibold tw-text-slate-900 dark:tw-text-white tw-text-sm font-work-sans tw-m-0"
                                                    style="line-height: 1.2;"
                                                >
                                                    {{ shop.name }}
                                                </p>
                                                <p
                                                    class="tw-text-xs tw-text-slate-500 dark:tw-text-slate-400 font-work-sans tw-m-0"
                                                    style="line-height: 1.2; margin-top: 2px !important;"
                                                >
                                                    {{ $t("zone.code") }}:
                                                    {{ shop.displayId }} |
                                                    {{ $t("zone.phone") }}:
                                                    {{ shop.phoneNumber }}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        class="tw-px-3 tw-py-2 tw-text-slate-600 dark:tw-text-slate-300 tw-hidden sm:tw-table-cell tw-text-sm"
                                    >
                                        {{ shop.address }}
                                    </td>
                                    <td
                                        class="tw-px-3 tw-py-2 tw-text-slate-600 dark:tw-text-slate-300"
                                    >
                                        <span
                                            class="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-md tw-bg-slate-100 dark:tw-bg-slate-800 tw-text-xs tw-font-medium"
                                        >
                                            {{ shop.category }}
                                        </span>
                                    </td>
                                    <td class="tw-px-3 tw-py-2 tw-text-right">
                                        <span
                                            :class="getStatusClass(shop.status)"
                                        >
                                            <span
                                                class="tw-inline-block tw-rounded-full"
                                                :class="
                                                    getStatusDotClass(
                                                        shop.status
                                                    )
                                                "
                                                style="width: 5px; height: 5px;"
                                            ></span>
                                            {{ shop.status }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Footer - Fixed -->
            <footer
                class="tw-shrink-0 tw-bg-white dark:tw-bg-slate-900 tw-border tw-border-slate-200 dark:tw-border-slate-800 tw-rounded-lg tw-py-4 tw-z-20"
            >
                <div
                    class="tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-between tw-gap-4 tw-px-8"
                >
                    <div class="tw-flex tw-items-center tw-gap-2">
                        <span
                            class="tw-flex tw-items-center tw-justify-center tw-size-6 tw-rounded-full tw-bg-primary/20 tw-text-primary tw-text-xs tw-font-bold font-work-sans"
                        >
                            {{ selectedShops.length }}
                        </span>
                        <span
                            class="tw-text-sm tw-font-medium tw-text-slate-700 dark:tw-text-slate-200 font-work-sans"
                        >
                            {{ $t("zone.shopSelected") }}
                        </span>
                    </div>
                    <div
                        class="tw-flex tw-items-center tw-gap-3 tw-w-full sm:tw-w-auto"
                    >
                        <button
                            @click="cancel"
                            class="tw-flex-1 sm:tw-flex-none tw-px-4 tw-py-2.5 tw-rounded-lg tw-border tw-border-slate-300 dark:tw-border-slate-700 tw-text-slate-700 dark:tw-text-slate-200 tw-font-medium tw-text-sm hover:tw-bg-slate-50 dark:hover:tw-bg-slate-800 tw-transition-colors font-work-sans"
                        >
                            {{ $t("cancel") }}
                        </button>
                        <button
                            @click="updateZone"
                            class="tw-flex-1 sm:tw-flex-none tw-px-6 tw-py-2.5 tw-rounded-lg tw-bg-blue-500 tw-text-white tw-font-medium tw-text-sm hover:tw-bg-blue-600 tw-transition-colors tw-shadow-sm tw-shadow-blue-500/20 dark:tw-shadow-none tw-flex tw-items-center tw-justify-center tw-gap-2 font-work-sans"
                        >
                            <span
                                class="material-symbols-outlined tw-text-[18px]"
                                >check</span
                            >
                            {{ $t("zone.updateZone") }}
                        </button>
                    </div>
                </div>
            </footer>
        </ts-loading-banner>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { debounce } from "lodash";

export default {
    name: "ZoneCreate",
    data() {
        return {
            shops: [],
            loading: false,
            errors: new Errors(),
            model: {
                name: "",
                remarks: "",
                shop_ids: []
            },
            searchQuery: "",
            activeCategory: "all",
            selectAll: false,
            selectedShops: [],
            businessCategories: [],
            shopTypes: [],
            categories: [{ id: "all", label: "All Shops" }]
        };
    },
    watch: {
        searchQuery(newVal) {
            this.debouncedSearch(newVal);
        },
        validate: function (error) {
			this.errors = new Errors(error.errors);
		}
    },
    created() {
        this.debouncedSearch = debounce(searchQuery => {
            this.getShopList(searchQuery);
        }, 500);
    },
    computed: {
        ...mapState("driver/zone", ["edit_data"])
    },
    methods: {
        ...mapActions("driver/zone", [
            "store",
            "shopList",
            "shopTypeList",
            "find"
        ]),
        sortShops() {
            this.shops.sort((a, b) => {
                const aSelected = this.selectedShops.includes(a.id);
                const bSelected = this.selectedShops.includes(b.id);

                if (aSelected && !bSelected) return -1;
                if (!aSelected && bSelected) return 1;
                return 0;
            });
        },

        getShopType() {
            this.shopTypeList()
                .then(response => {
                    this.businessCategories = response.business_categories;
                    this.shopTypes = response.shop_types;

                    // Build categories array dynamically
                    this.categories = [{ id: "all", label: "All Shops" }];

                    // Add business categories
                    this.businessCategories.forEach(cat => {
                        this.categories.push({
                            id: `business_${cat.business_category_id}`,
                            label: cat.business_category,
                            type: "business_category",
                            value: cat.business_category_id
                        });
                    });

                    // Add shop types
                    this.shopTypes.forEach(type => {
                        this.categories.push({
                            id: `shop_type_${type.shop_type_id}`,
                            label: type.shop_type,
                            type: "shop_type",
                            value: type.shop_type_id
                        });
                    });
                })
                .catch(err => {
                    this.$notify({ type: "error", text: err.message });
                });
        },

        getShopList(searchQuery = "", categoryFilter = null) {
            const isInitialLoad = !searchQuery && !categoryFilter;

            if (!isInitialLoad) {
                this.loading = true;
            }

            const params = {};

            if (this.$route.params.id) {
                params.zone_id = this.$route.params.id;
            }
            if (searchQuery) {
                params.search = searchQuery;
            }

            if (categoryFilter && categoryFilter.type === "business_category") {
                params.business_category_id = categoryFilter.value;
            } else if (categoryFilter && categoryFilter.type === "shop_type") {
                params.shop_type_id = categoryFilter.value;
            }

            const options = Object.keys(params).length > 0 ? { params } : {};

            return this.shopList(options)
                .then(response => {
                    const mappedShops = response.data.map(shop => ({
                        id: shop.shop_id,
                        displayId: shop.shop_code,
                        name: shop.shop_name,
                        address: shop.address_1 || "N/A",
                        category: shop.business_category || "N/A",
                        categoryId: shop.business_category_id,
                        shopTypeId: shop.shop_type_id,
                        status: shop.is_active ? "Active" : "Inactive",
                        icon: this.getShopIcon(shop.business_category_id),
                        iconBg: this.getShopIconBg(shop.business_category_id),
                        phoneNumber: shop.phone_number
                    }));

                    // Sort BEFORE assigning to this.shops
                    mappedShops.sort((a, b) => {
                        const aSelected = this.selectedShops.includes(a.id);
                        const bSelected = this.selectedShops.includes(b.id);

                        if (aSelected && !bSelected) return -1;
                        if (!aSelected && bSelected) return 1;
                        return 0;
                    });

                    // Now assign the already-sorted array
                    this.shops = mappedShops;
                })
                .catch(err => {
                    this.$notify({ type: "error", text: err.message });
                })
                .finally(() => {
                    if (!isInitialLoad) {
                        this.loading = false;
                    }
                });
        },

        getShopIcon(categoryId) {
            switch (categoryId) {
                case 1:
                    return "restaurant";
                case 2:
                    return "store";
                default:
                    return "storefront";
            }
        },

        getShopIconBg(categoryId) {
            switch (categoryId) {
                case 1:
                    return "tw-bg-orange-50 dark:tw-bg-orange-900/20 tw-text-orange-500 dark:tw-text-orange-400";
                case 2:
                    return "tw-bg-blue-100 dark:tw-bg-blue-900/30 tw-text-blue-600 dark:tw-text-blue-400";
                default:
                    return "tw-bg-slate-100 dark:tw-bg-slate-900/30 tw-text-slate-600 dark:tw-text-slate-400";
            }
        },

        getStatusClass(status) {
            const baseClass = "status-badge";
            switch (status) {
                case "Active":
                    return `${baseClass} status-active`;
                case "Inactive":
                case "Offline":
                    return `${baseClass} status-inactive`;
                default:
                    return baseClass;
            }
        },

        getStatusDotClass(status) {
            const baseClass = "status-dot";
            switch (status) {
                case "Active":
                    return `${baseClass} status-dot-active`;
                case "Closing Soon":
                    return `${baseClass} status-dot-closing`;
                case "Inactive":
                case "Offline":
                    return `${baseClass} status-dot-inactive`;
                default:
                    return baseClass;
            }
        },

        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedShops = this.shops.map(shop => shop.id);
            } else {
                this.selectedShops = [];
            }
        },
        handleCategoryClick(category) {
            this.activeCategory = category.id;

            if (category.id === "all") {
                this.getShopList(this.searchQuery);
            } else {
                this.getShopList(this.searchQuery, category);
            }
        },

        cancel() {
            this.$router.push({ name: "zone" });
        },

        updateZone() {
            this.model.shop_ids = this.selectedShops;

            this.errors = new Errors();
            this.loading = true;

            this.$store
                .dispatch("driver/zone/update", {
                    id: this.edit_data.id,
                    data: this.model
                })
                .then(response => {
                    this.$notify({ type: "success", text: response.message });
                    this.$router.push({ name: "zone" });
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.$notify({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        async setEdit() {
            await this.find(this.$route.params.id);
            this.model.name = this.edit_data.name;
            this.model.remarks = this.edit_data.remarks;
            this.assignedShops = this.edit_data.active_shops.map(shop => ({
                id: shop.shop_id,
                name: shop.shop_name,
                code: shop.shop_code,
                category: shop.business_category_id,
                address: shop.address_1 || "",
                status: shop.is_active ? "active" : "inactive",
                pivot: shop.pivot
            }));

            // Populate checkboxes with pre-selected shop IDs
            this.selectedShops = this.assignedShops.map(shop => shop.id);
        },
        goBack() {
            if (this.$router) {
                this.$router.push("/admin/driver/zones");
            }
        }
    },
    async mounted() {
    this.loading = true;
    try {
        await this.setEdit();
        await this.getShopList();
        await this.getShopType();
    } catch (error) {
        this.$notify({ type: "error", text: error.message });
    } finally {
        this.loading = false;
    }
},

    beforeRouteLeave(to, from, next) {
        this.$store.commit("driver/zone/SET_EDIT_DATA", []);
        this.$store.commit("driver/zone/RESET_STATE");
        next();
    }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap");
</style>

<style scoped>
/* ============================================
   TABLE HEADER - STICKY
   ============================================ */
.table-header-fixed {
    background-color: #f8fafc !important;
    position: sticky;
    top: 0;
    z-index: 10;
    color: #64748b !important;
}

.table-header-fixed th {
    background-color: #f8fafc !important;
    color: #64748b !important;
    position: sticky;
    top: 0;
}

.dark .table-header-fixed {
    background-color: #0f172a !important;
    color: #64748b !important;
}

.dark .table-header-fixed th {
    background-color: #0f172a !important;
    color: #64748b !important;
}
/* ============================================
   TYPOGRAPHY & FONTS
   ============================================ */
.font-work-sans {
    font-family: "Work Sans", sans-serif !important;
}

.heading-dark {
    color: #000000;
}

.dark .heading-dark {
    color: #ffffff;
}

/* ============================================
   SEARCH INPUT
   ============================================ */
.search-input::placeholder {
    color: #94a3b8 !important;
    opacity: 1;
}

.search-icon {
    color: #94a3b8;
}

.material-symbols-outlined {
    color: #94a3b8;
}

/* ============================================
   SHOP ICON CONTAINER
   ============================================ */
.shop-icon-container {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Food category - Orange background */
.shop-icon-container.tw-bg-orange-50 {
    background-color: #fff7ed !important;
}

.shop-icon-container.tw-bg-orange-50 .material-symbols-outlined {
    color: #f97316 !important;
}

/* Non-Food category - Blue background */
.shop-icon-container.tw-bg-blue-100 {
    background-color: #dbeafe !important;
}

.shop-icon-container.tw-bg-blue-100 .material-symbols-outlined {
    color: #3b82f6 !important;
}

/* Default - Gray background */
.shop-icon-container.tw-bg-slate-100 {
    background-color: #f1f5f9 !important;
}

.shop-icon-container.tw-bg-slate-100 .material-symbols-outlined {
    color: #64748b !important;
}

/* Dark mode */
.dark .shop-icon-container.tw-bg-orange-50 {
    background-color: rgba(249, 115, 22, 0.2) !important;
}

.dark .shop-icon-container.tw-bg-blue-100 {
    background-color: rgba(59, 130, 246, 0.3) !important;
}

.dark .shop-icon-container.tw-bg-slate-100 {
    background-color: rgba(15, 23, 42, 0.3) !important;
}

/* ============================================
   STATUS BADGES
   ============================================ */
.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.75rem;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 9999px;
    border: 1px solid transparent;
}

.status-active {
    color: #059669;
    background-color: #ecfdf5;
    border-color: #d1fae5;
}

.status-inactive {
    color: #64748b;
    background-color: #f1f5f9;
    border-color: #f1f5f9;
}

.status-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

.status-dot-active {
    background-color: #10b981;
}

.status-dot-inactive {
    background-color: #94a3b8;
}

/* Dark mode status badges */
.dark .status-active {
    color: #34d399;
    background-color: rgba(16, 185, 129, 0.15);
    border-color: rgba(16, 185, 129, 0.3);
}

.dark .status-inactive {
    color: #cbd5e1;
    background-color: rgba(100, 116, 139, 0.2);
    border-color: rgba(100, 116, 139, 0.3);
}

/* ============================================
   TABLE HEADER
   ============================================ */
.table-header-fixed {
    background-color: #f8fafc !important;
    position: sticky;
    top: 0;
    z-index: 10;
    color: #64748b !important;
}

.table-header-fixed th {
    background-color: #f8fafc !important;
    color: #64748b !important;
}

.dark .table-header-fixed {
    background-color: rgba(15, 23, 42, 0.5) !important;
    color: #64748b !important;
}

.dark .table-header-fixed th {
    background-color: rgba(15, 23, 42, 0.5) !important;
    color: #64748b !important;
}

/* ============================================
   SCROLLBAR
   ============================================ */
.custom-scrollbar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 20px;
}

.dark .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: #475569;
}

/* ============================================
   SELECTED ROW STYLES
   ============================================ */
.selected-row {
    background-color: #eff6ff !important; /* Light blue background */
    position: relative;
}

.dark .selected-row {
    background-color: rgba(59, 130, 246, 0.1) !important;
}

.selected-row-indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background-color: #3b82f6; /* Blue line */
}

/* ============================================
   CHECKBOX STYLES
   ============================================ */
.custom-checkbox {
    appearance: none;
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border: 1.5px solid #cbd5e1;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    position: relative;
    transition: all 0.2s;
}

.custom-checkbox:checked {
    background-color: #3b82f6;
    border-color: #3b82f6;
}

.custom-checkbox:checked::after {
    content: "✓";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 12px;
    font-weight: bold;
}

.custom-checkbox:hover {
    border-color: #3b82f6;
}

.dark .custom-checkbox {
    background-color: #1e293b;
    border-color: #475569;
}

.dark .custom-checkbox:checked {
    background-color: #3b82f6;
    border-color: #3b82f6;
}
</style>
